// hooks/usePageTracking.ts
"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { useAnalytics } from "@/components/AnalyticsProvider";

const usePageTracking = () => {
  const { analytics } = useAnalytics();
  const pathname = usePathname();

  useEffect(() => {
    if (analytics) {
      analytics.page();
    }
  }, [analytics, pathname]);
};

export default usePageTracking;
